import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ChevronRight } from "lucide-react";

interface YearTopicCardProps {
  yearLevel: string | number;
  topicCount: number;
  gradeLevel: string;
  onClick: () => void;
}

export default function YearTopicCard({
  yearLevel,
  topicCount,
  gradeLevel,
  onClick
}: YearTopicCardProps) {
  const hasTopics = topicCount > 0;

  return (
    <Card
      className={`p-6 transition-all ${
        hasTopics
          ? "cursor-pointer hover:-translate-y-1 hover:shadow-lg hover-elevate active-elevate-2"
          : "opacity-50 cursor-not-allowed"
      }`}
      onClick={hasTopics ? onClick : undefined}
      data-testid={`card-year-${yearLevel}`}
    >
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <h3 className="text-2xl font-bold font-serif text-primary">
              {String(yearLevel).match(/^\d+$/) ? `Year ${yearLevel}` : String(yearLevel)}
            </h3>
            <Badge variant="secondary" data-testid={`badge-grade-${yearLevel}`}>
              {gradeLevel}
            </Badge>
          </div>
          <p className="text-sm text-muted-foreground">
            {topicCount === 1 ? "1 topic available" : `${topicCount} topics available`}
          </p>
        </div>
        {hasTopics && <ChevronRight className="h-6 w-6 text-muted-foreground" />}
      </div>
    </Card>
  );
}
